import { css } from 'linaria';

const videoWrapper = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
`;

const video = css`
  object-fit: cover;
  object-position: center center;
  width: 100%;
  height: 100%;
`;

const fallbackVideoImage = css`
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 0;
`;

export const classNames = {
  videoWrapper,
  video,
  fallbackVideoImage,
};
